var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNormalPack5 = function SvgNormalPack5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#normal-pack5_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#normal-pack5_svg__b)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.823,
    cy: 195.668,
    rx: 69.139,
    ry: 24.259,
    fill: "#FEAE52"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.01 134.398c0 48.159-41.739 87.334-93.398 87.334-51.66 0-93.399-39.175-93.399-87.334 0-48.159 41.739-87.334 93.399-87.334 51.659 0 93.398 39.175 93.398 87.334Z",
    fill: "#FED052",
    stroke: "url(#normal-pack5_svg__c)",
    strokeWidth: 2.426
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.612,
    cy: 134.398,
    rx: 94.611,
    ry: 88.547,
    fill: "url(#normal-pack5_svg__d)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.398,
    cy: 77.389,
    rx: 64.287,
    ry: 36.389,
    fill: "url(#normal-pack5_svg__e)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48,
    filter: "url(#normal-pack5_svg__f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.453,
    cy: 144.103,
    rx: 32.75,
    ry: 18.195,
    fill: "url(#normal-pack5_svg__g)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48,
    filter: "url(#normal-pack5_svg__h)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.342,
    cy: 144.103,
    rx: 32.75,
    ry: 18.195,
    fill: "url(#normal-pack5_svg__i)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 98.309,
    cy: 120.945,
    r: 23.094,
    fill: "url(#normal-pack5_svg__j)",
    stroke: "url(#normal-pack5_svg__k)",
    strokeWidth: 1.499
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.311,
    cy: 120.944,
    r: 3.406,
    fill: "url(#normal-pack5_svg__l)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.634,
    cy: 120.944,
    r: 23.094,
    fill: "url(#normal-pack5_svg__m)",
    stroke: "url(#normal-pack5_svg__n)",
    strokeWidth: 1.499
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.633,
    cy: 120.944,
    r: 3.406,
    fill: "url(#normal-pack5_svg__o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.102 171.436 8.841 10.124a2.805 2.805 0 0 0 4.283-.068l9.698-11.845a2.805 2.805 0 0 1 4.171-.189l12.154 12.371a2.805 2.805 0 0 0 4.171-.189l9.377-11.453a2.805 2.805 0 0 1 4.517.24l7.021 10.719a2.804 2.804 0 0 0 4.347.429l9.962-10.139",
    stroke: "url(#normal-pack5_svg__p)",
    strokeWidth: 5.61,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "normal-pack5_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 36.389 -64.2872 0 131.398 77.389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#FCF2BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCF2BD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "normal-pack5_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.21296 14.55565 -26.20009 2.18332 80.453 144.103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0B0A",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0B0A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "normal-pack5_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.21296 14.55565 -26.20009 2.18332 182.342 144.103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0B0A",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0B0A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "normal-pack5_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 -11.318 109.627) scale(23.8431)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "normal-pack5_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 -11.317 109.627) scale(3.40616)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#552313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "normal-pack5_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 22.845 143.789) scale(23.8431)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEDE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "normal-pack5_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 22.844 143.789) scale(3.40616)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#552313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151515"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "normal-pack5_svg__c",
    x1: 38,
    y1: 141.676,
    x2: 227.223,
    y2: 140.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D39D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#FDCA4D",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4D39D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "normal-pack5_svg__d",
    x1: 132.612,
    y1: 187.768,
    x2: 132.612,
    y2: 222.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2BD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD58F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "normal-pack5_svg__k",
    x1: 98.309,
    y1: 97.102,
    x2: 98.309,
    y2: 144.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC03F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE684"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "normal-pack5_svg__n",
    x1: 166.634,
    y1: 97.101,
    x2: 166.634,
    y2: 144.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC03F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFE684"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "normal-pack5_svg__p",
    x1: 94.102,
    y1: 175.644,
    x2: 172.644,
    y2: 175.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#512214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#261915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "normal-pack5_svg__b",
    x: 11.071,
    y: 117.795,
    width: 245.504,
    height: 155.745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.807,
    result: "effect1_foregroundBlur_747_116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "normal-pack5_svg__f",
    x: 32.419,
    y: 110.625,
    width: 96.067,
    height: 66.956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.642,
    result: "effect1_foregroundBlur_747_116"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "normal-pack5_svg__h",
    x: 134.309,
    y: 110.625,
    width: 96.067,
    height: 66.956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.642,
    result: "effect1_foregroundBlur_747_116"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "normal-pack5_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h270v270H0z"
  })))));
};
export default SvgNormalPack5;